import { useState, useEffect } from "react";
import {
  PaletteColor,
  PaletteColorHex,
  PaletteColorBg,
  PaletteColorDarkBg,
  PaletteColorDarkHex,
} from "../types/PaletteColor.ts";

// ダークモードの状態を監視するカスタムフック
export const useDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          setIsDarkMode(document.documentElement.classList.contains("dark"));
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    return () => observer.disconnect();
  }, []);

  return isDarkMode;
};

// PaletteColorのダークモード対応ヘルパーフック
export const usePaletteColors = (color: PaletteColor) => {
  const isDarkMode = useDarkMode();

  return {
    isDarkMode,
    // テキスト色: ダークモードでは明るい背景色、ライトモードでは濃い色
    textColor: isDarkMode ? PaletteColorBg[color] : PaletteColorHex[color],
    // 背景色: ダークモードでは暗い背景色、ライトモードでは薄い背景色
    bgColor: isDarkMode ? PaletteColorDarkBg[color] : PaletteColorBg[color],
    // アクセント色: ダークモードでは明るめのDarkHex色
    accentColor: isDarkMode
      ? PaletteColorDarkHex[color]
      : PaletteColorHex[color],
    // 元の値も提供
    hex: PaletteColorHex[color],
    bg: PaletteColorBg[color],
    darkBg: PaletteColorDarkBg[color],
    darkHex: PaletteColorDarkHex[color],
  };
};
